 <template>
  <div id="app">
    <Transition>
      <div v-if="showTutorial" class="tutorial-overlay"></div>
    </Transition>
    <Transition>
      <div v-if="showTutorial" class="quit-tutorial-container-container">
        <div class="quit-tutorial-container">
          <button class="tutorial-close-btn btn btn-primary" @click="quitTutorial">Hide tutorial once</button>
          <button class="tutorial-close-btn btn btn-primary" @click="quitTutorialPermanently">Hide tutorial forever</button>
        </div>
      </div>
    </Transition>

    <nav
      class="navbar navbar-expand-lg navbar-light mb-3 pb-2"
      v-if="$route.meta.navigationAvailable"
    >
      <a class="navbar-brand d-flex align-items-center" href="/scenarios">
        <img style="width:200px" src="./assets/GS_corpuls_white.png" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarText"
        aria-controls="navbarText"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarText">
        <ul class="navbar-nav mr-auto"></ul>

        <router-link
          tag="button"
          class="btn btn-outline btn-primary mr-2 flex-grow d-none d-lg-block"
          to="/scenarios"
        >
          <div style="display:flex; align-items:center">
            <i class="material-icons" style="margin-right:7px">insert_chart_outlined</i>
            Scenarios
          </div>
        </router-link>
        <!-- <router-link
          tag="button"
          class="btn btn-primary mr-2 flex-grow d-none d-lg-block"
          to="/media"
        >
          <div style="display:flex; align-items:center">
            <i class="material-icons" style="margin-right:7px">perm_media</i>
            Media
          </div>
        </router-link> -->

        <div
          class="position-relative"
          :class="[showTutorial ? 'no-overlay no-click' : '']"
        >
          <router-link
            v-if="user.canProvision"
            tag="button"
            class="btn btn-primary mr-2 flex-grow d-none d-lg-block"
            to="/me/provisioning"
          >
            <div style="display:flex; align-items:center">
              <i class="material-icons" style="margin-right:7px">note</i>
              Licensing
            </div>
          </router-link>

          <div v-if="showTutorial && user.canProvision" class="tutorial--arrow-top license-tutorial">
            Here, the current iPad can be licensed.
          </div>
        </div>

        <DeviceInformation v-if="user.canProvision" ref="mainContent"></DeviceInformation>
        <LoggedInUser v-if="user"></LoggedInUser>
      </div>
    </nav>
    <div
      v-if="$route.meta.navigationAvailable"
      class="breadcrumbs-container align-items-center flat bg-light container-fluid d-block d-flex py-3 mb-3"
    >
      <router-link class="d-flex align-items-center" to="/">
        <i class="material-icons mr-2">home</i>
      </router-link>
      <app-breadcrumbs></app-breadcrumbs>
    </div>
    <div id="main-content" ref="main-content" class="container-fluid">
      <div class="row">
        <div class="col-12" v-bind:class="{ 'col-lg-9' : $route.meta.navigationAvailable }">
          <router-view />
        </div>

        <div class="col-md-3 d-none d-lg-block" v-if="$route.meta.navigationAvailable">
          <FavouriteScenariosList :key="favouritedScenariosKey"></FavouriteScenariosList>
        </div>
        <div
          v-if="$route.meta.navigationAvailable"
          class="mobile-scenarios-button d-block d-lg-none"
        >
          <a class href="/scenarios">
            <button class="btn btn-primary d-flex align-items-center justify-content-center">
              <i class="material-icons">insert_chart</i>
            </button>
          </a>
        </div>
        <div v-if="$route.meta.navigationAvailable" class="mobile-back-button d-block d-lg-none">
          <a class @click="$router.go(-1)">
            <button class="btn btn-primary d-flex align-items-center justify-content-center">
              <i class="material-icons">arrow_back</i>
            </button>
          </a>
        </div>
      </div>
    </div>
    <div v-if="$route.meta.navigationAvailable">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import LoggedInUser from "./components/LoggedInUser.vue";
import DeviceInformation from "./components/DeviceInformation.vue";
import ScenService from "./services/scenarios.service";
import FavouriteScenario from "./components/FavouriteScenario";
import FavouriteScenariosList from "./components/FavouriteScenariosList";
import Footer from "./components/Footer";
import storage from "store";
import "./assets/css/global.css";
import router from "@/router";

export default {
  name: "App",
  computed: {
    appLoading() {
      return this.$store.getters.getAppLoading;
    },
    authed() {
      return this.$store.getters.getAuthed;
    },
    user() {
      return this.$store.getters.getUser;
    },
    deviceInfo() {
      return this.$store.getters.getDeviceInfo;
    },
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    },
    showTutorial() {
      return this.$store.getters.getShowTutorial;
    }
  },
  watch: {
    showTutorial(newVal) {
      if (newVal) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
    }
  },
  mounted() {
    if (this.showTutorial) {
      document.body.classList.add("overflow-hidden");
    }
  },
  data: function() {
    return {
      favouritedScenariosKey: 0,
    };
  },

  methods: {
    setDeviceInfo(device_id, product) {
      let deviceInfo = {
        device_id: device_id,
        product: product
      };
      this.$store.commit("setDeviceInfo", deviceInfo);
    },
    setIsOnNative() {
      let isOnNative = window.webkit != null;
      this.$store.commit("setIsOnNative", isOnNative);
      if (this.isOnNative) {
        window.webkit.messageHandlers.getDeviceInfo.postMessage("request");
      }
    },
    updateFavouriteScenariosList() {
      this.favouritedScenariosKey += 1;
    },
    quitTutorial() {
      this.$store.commit("setShowTutorial", false);
    },
    quitTutorialPermanently() {
      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure you wish to hide the tutorial permanently?",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Confirm"
        })
        .then(result => {
          if (result.value) {
            this.$store.commit("setHideTutorialPermanently", true);
            this.$store.commit("setShowTutorial", false);
          }
        });
    }
  },
  components: {
    LoggedInUser,
    DeviceInformation,
    FavouriteScenario,
    FavouriteScenariosList,
    Footer
  },
  beforeMount() {
    window.setDeviceInfo = this.setDeviceInfo;
    this.setIsOnNative();

    // We don't want to show the 'change password' screen when Community
    // is opened within the app, so force the user to login again.
    if (
      this.$store.getters.getIsOnNative &&
      this.$store.getters.getUser.force_password_change
    ) {
      if (
        this.$route.path.toLowerCase() !== "/logout" &&
        this.$route.path.toLowerCase() !== "/login"
      ) {
        router.replace("/logout");
      }
    }
  }
};
</script>

<style>
[v-cloak] {
  display: none;
}
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
}

.bg-white {
}

@media (max-width: 991px) {
  #app {
    margin-bottom: 100px;
  }
}

h2,
h3,
h4,
h5 {
  color: #CB2E37;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
}
h2,
h3 {
  font-weight: 600;
}

h4,
h5 {
}

.favourite-scenarios {
  padding: 0;
}

.favourite-scenarios li {
}
nav {
  background-image: url("assets/stripes-light2.png");
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 ); /* IE6-9 */
}
/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .reverse-mobile {
    flex-direction: column-reverse;
  }
}

.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(0, 10, 0, 0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(35px);
  opacity: 0;
}

.fast-fade-enter-active {
  transition: all 0.1s ease;
}
.fast-fade-leave-active {
  transition: all 0.1s cubic-bezier(0, 10, 0, 0);
}
.fast-fade-enter, .fast-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(40px);
  opacity: 0;
}

.mobile-back-button {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 0px 15px 15px 0px;
}

.mobile-back-button {
  box-shadow: 0px 17px 10px -10px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: all ease-in-out 300ms;
}

.mobile-back-button i {
  padding: 7px;
  font-size: 30px;
}

.mobile-back-button:hover {
  box-shadow: 0px 37px 20px -15px rgba(0, 0, 0, 0.2);
  transform: translate(0px, -10px);
}

.mobile-scenarios-button {
  position: fixed;
  bottom: 0;
  right: left;
  margin: 0px 0px 15px 15px;
}

.mobile-scenarios-button {
  box-shadow: 0px 17px 10px -10px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: all ease-in-out 300ms;
}

.mobile-scenarios-button i {
  padding: 7px;
  font-size: 30px;
}

.mobile-scenarios-button:hover {
  box-shadow: 0px 37px 20px -15px rgba(0, 0, 0, 0.2);
  transform: translate(0px, -10px);
}

#app {
  min-height: 100vh;
}

.btn-success {
  background: #7d7d7d;
  border-color: #7d7d7d;
}

.btn-primary:active,
.btn-primary:focus {
  background: #CB2E37;
}

.btn-success:hover {
  background: #CB2E37;
  border-color: #CB2E37;
}

.btn-success:active,
.btn-success:focus {
  background: #CB2E37 !important;
  border-color: #CB2E37 !important;
  outline: #CB2E37 !important;
  box-shadow: #CB2E37 !important;
}

ul.breadcrumbs-container {
  list-style: none;
  display: flex;
  margin: 0px;
  padding: 0px;
}

ul.breadcrumbs-container li {
  margin-right: 12px;
}

ul.breadcrumbs-container li {
  color: #6c757d;
  margin-right: 10px;
  font-size: 1em;
  font-style: italic;
}

ul.breadcrumbs-container li::after {
}

/* breadcrumb */

.breadcrumb-arrow {
  min-height: 36px;
  /*     padding: 0; */
  line-height: 36px;
  list-style: none;
  overflow: auto;
  /*    background-color: #e6e9ed*/
  /*background: linear-gradient(to right, #eaeaea 0%,#ffffff 100%);*/
}

ul.breadcrumbs-container lili:first-child a {
  border-radius: 4px 0 0 4px;
  -webkit-border-radius: 4px 0 0 4px;
  -moz-border-radius: 4px 0 0 4px;
}

ul.breadcrumbs-container lili,
ul.breadcrumbs-container lili a,
.breadcrumb-arrow li span {
  display: inline-block;
  /*vertical-align: top;*/
}

.breadcrumb-arrow li:not(:first-child) {
  margin-left: -5px;
}

.breadcrumb-arrow li + li:before {
  padding: 0;
  content: "";
}

.breadcrumb-arrow li span {
  padding: 0 10px;
}

.breadcrumb-arrow li a,
.breadcrumb-arrow li:not(:first-child) span {
  height: 36px;
  padding: 0 10px 0 25px;
  line-height: 36px;
}

.breadcrumb-arrow li:first-child a {
  padding: 0 10px;
}

.breadcrumb-arrow li a {
  position: relative;
  color: #fff;
  text-decoration: none;
  background-color: #343a40;
  border: 1px solid #343a40;
}

.breadcrumb-arrow li:first-child a {
  padding-left: 10px;
}

.breadcrumb-arrow li a:after,
.breadcrumb-arrow li a:before {
  position: absolute;
  top: -1px;
  width: 0;
  height: 0;
  content: "";
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
}

.breadcrumb-arrow li a:before {
  right: -10px;
  z-index: 3;
  border-left-color: #343a40;
  border-left-style: solid;
  border-left-width: 10px;
}

.breadcrumb-arrow li a:after {
  right: -11px;
  z-index: 2;
  border-left: 11px solid #fff;
}

.breadcrumb-arrow li a:focus,
.breadcrumb-arrow li a:hover {
  background-color: #40474e;
  border: 1px solid #40474e;
}

.breadcrumb-arrow li a:focus:before,
.breadcrumb-arrow li a:hover:before {
  border-left-color: #40474e;
}

.breadcrumb-arrow li a:active {
  background-color: #40474e;
  border: 1px solid #40474e;
}

.breadcrumb-arrow li a:active:after,
.breadcrumb-arrow li a:active:before {
  border-left-color: #40474e;
}

/*set for Last child*/

.breadcrumb-arrow li.active span {
  position: relative;
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
  border: 1px solid #007bff;
}

.breadcrumb-arrow li.active:first-child span {
  padding-left: 10px;
}

.breadcrumb-arrow li.active span:after,
.breadcrumb-arrow li.active span:before {
  position: absolute;
  top: -1px;
  width: 0;
  height: 0;
  content: "";
  border-top: 18px solid transparent;
  border-bottom: 18px solid transparent;
}

.breadcrumb-arrow li.active span:before {
  right: -10px;
  z-index: 3;
  border-left-color: #007bff;
  border-left-style: solid;
  border-left-width: 11px;
}

.breadcrumb-arrow li.active span:after {
  right: -11px;
  z-index: 2;
  border-left: 10px solid #007bff;
}

.router-link-active.btn.btn-primary {
  background-color: #CB2E37;
}

.favourite-icon {
  font-size: 20px;
  color: #6c757d;
}
.navbar { background:#040603 }

.tutorial-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(107, 107, 107, 0.9);
  z-index: 1000;
}

.license-tutorial {
  top: 45px;
  left: 0;
  right: 8px;
}

.quit-tutorial-container-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 250px;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1100;
}

.quit-tutorial-container {
  width: fit-content;
  margin: calc(250px / 2 - 1.5rem) auto;
}

.quit-tutorial-container button {
  margin-left: 10px;
  margin-right: 10px;
  font-size: x-large;
  font-weight: bold;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
